export const Event = {
  SIDEBAR: {
    NOTIFY_EVENT: "leave-updated",
  },
  USER: {
    PROFILE_IMAGE_UPDATED: "profile-image-updated",
  },
};
